module.exports = __webpack_public_path__ + "static/media/up-arrow.1c0244e6.png";